<template>
  <div id="app">
	<!-- 再次标签上,用来切换不同的组件  -->
    <router-view></router-view>
    
  </div>
</template>

<script>


export default {
  name: 'app',
}
</script>

<style>

</style>
